import PageHero from "@/components/PageHero";
import FAQ from "@/components/FAQ";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { FAQ_ITEMS } from "@/lib/data";
import { buildFAQSchema } from "@/lib/seoSchemas";
import { ArrowRight, MessageCircleQuestion } from "lucide-react";

const FAQPage = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [buildFAQSchema(FAQ_ITEMS)],
  };

  return (
    <div data-testid="page-faq">
      <SEO
        title="FAQ, Questions fréquentes sur la conciergerie Airbnb"
        description="Toutes les réponses aux questions des propriétaires : flexibilité, clés, caution, assurances, fiscalité, communication voyageurs, revenus Airbnb. Conciergerie 24h/24 · 7j/7 en Bretagne."
        keywords="FAQ conciergerie Airbnb, questions location courte durée, AirCover caution, fiscalité Airbnb, Bretagne Côte d'Émeraude"
        jsonLd={jsonLd}
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "FAQ", path: "/faq" },
        ]}
      />
      <PageHero
        overline="Foire aux questions"
        title="Vos questions,"
        italic="nos réponses claires"
        description="Tout ce qu'un propriétaire doit savoir avant, pendant et après la mise en location courte durée de son bien, flexibilité, caution, fiscalité, communication voyageurs."
        image="/images/faq-equipe-questions.jpg"
        cta={{ to: "/contact", label: "Poser une autre question" }}
      />

      <FAQ />

      {/* Bottom CTA */}
      <section className="py-16 lg:py-20 bg-cream border-t border-gold/20" data-testid="faq-bottom-cta">
        <div className="container-tm">
          <div className="bg-ink rounded-3xl p-10 md:p-14 text-white grain-overlay relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-[400px] h-[400px] bg-gold/20 rounded-full blur-[120px] pointer-events-none" />
            <div className="relative grid lg:grid-cols-2 gap-10 items-center">
              <div>
                <span className="overline text-gold flex items-center gap-2">
                  <MessageCircleQuestion size={16} strokeWidth={2} /> Une question spécifique ?
                </span>
                <h3 className="mt-4 font-serif font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
                  Échangeons de vive voix,
                  <span className="italic text-gold"> 15 minutes suffisent</span>.
                </h3>
                <p className="mt-5 font-sans text-base text-white/70 max-w-xl leading-relaxed">
                  Notre équipe répond à toutes vos questions sans engagement. Étude gratuite et personnalisée du potentiel de votre logement.
                </p>
              </div>
              <div className="flex flex-wrap gap-3 lg:justify-end">
                <Link
                  to="/contact"
                  className="btn-accent group"
                  data-testid="faq-cta-contact"
                >
                  Nous contacter
                  <ArrowRight size={14} strokeWidth={2} className="ml-3 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
